export enum ValidatorStatus {
  UNSPECIFIED = 0,
  UNBONDED = 1,
  UNBONDING = 2,
  BONDED = 3,
}

export interface ValidatorDescription {
  moniker: string;
  identity: string;
  website: string;
  security_contact: string;
  details: string;
}

export interface ValidatorInfo {
  operator_address: string;
  consensus_pubkey?: string;
  jailed: boolean;
  status: number;
  tokens: string;
  delegator_shares: string;
  description?: ValidatorDescription;
  unbonding_height: number;
  unbonding_time?: string;
  commission?: string;
  min_self_delegation: string;
}

export interface StakingInfo {
  apr: string;
  total_bonded: string;
  total_supply: string;
}

export interface DelegationInfo {
  delegator_address: string;
  validator_address: string;
  shares: string;
}

export interface Balance {
  denom: string;
  amount: string;
  /** Token symbol for display (e.g., "GRAV", "ATOM") */
  symbol: string;
  /** Token decimals for formatting */
  decimals: number;
  /** Human-readable formatted amount (e.g., "1,234.56") */
  amount_display: string;
}

export interface DelegationResponse {
  delegation: DelegationInfo;
  balance: Balance;
}

export interface ValidatorReward {
  validator_address: string;
  reward: Balance[];
}

export interface RewardsResponse {
  rewards: ValidatorReward[];
  total: Balance[];
}

export interface UnbondingDelegation {
  delegator_address: string;
  validator_address: string;
  creation_height: number;
  completion_time: string;
  initial_balance: string;
  balance: string;
}

export interface DelegatorResponse {
  delegations: DelegationResponse[];
  unbonding_delegations?: UnbondingDelegation[];
  rewards: RewardsResponse;
}

// Additional legacy types for backward compatibility
export interface Validator {
  operator_address: string;
  consensus_pubkey: {
    type_url: string;
    value: Uint8Array;
  };
  jailed: boolean;
  status: ValidatorStatus;
  tokens: string;
  delegator_shares: string;
  description: ValidatorDescription;
  unbonding_height: string;
  unbonding_time: string;
  commission: Commission;
  min_self_delegation: string;
}

export interface CommissionRates {
  rate: string;
  max_rate: string;
  max_change_rate: string;
}

export interface Commission {
  commission_rates: CommissionRates;
  update_time: string;
}

export interface Delegation {
  delegator_address: string;
  validator_address: string;
  shares: string;
}

export interface UnbondingDelegationEntry {
  creation_height: string;
  completion_time: string;
  initial_balance: string;
  balance: string;
}

export interface Redelegation {
  delegator_address: string;
  validator_src_address: string;
  validator_dst_address: string;
  entries: RedelegationEntry[];
}

export interface RedelegationEntry {
  creation_height: string;
  completion_time: string;
  initial_balance: string;
  shares_dst: string;
}

/**
 * Reward info for a single validator with formatted balance data
 */
export interface ValidatorRewardInfo {
  validator_address: string;
  rewards: Balance[];
}
